import { render, staticRenderFns } from "./EventEditPage.vue?vue&type=template&id=d6a1c2e8"
import script from "./EventEditPage.vue?vue&type=script&lang=js"
export * from "./EventEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports